import { ConnectorNames } from '@pancakeswap/uikit'
import { useRef } from 'react'
import useAuth from './useAuth'

export const useSBID = () => {
  const { login } = useAuth()
  const connector = useRef<unknown | null>(null)

  const showSBIDModal = async (authSuccess: (token: string | null) => void, authError: () => void) => {
    import('utils/ssoConnector').then(async ({ SSOConnector }) => {
      if (!connector.current) {
        connector.current = await login(ConnectorNames.StoboxSSO)
      }

      if (!connector.current) {
        authError()
      }

      if (connector.current instanceof SSOConnector) {
        const { library } = SSOConnector
        library.authSuccess = (token: string | null) => {
          if (token) {
            library.closeLibrary()
            authSuccess(token)
          }
        }
        library.authFailed = authError
        await connector.current.signInWithSBID()
      }
    })
  }

  return {
    showSBIDModal,
  }
}
